require([
],
    function () {

        // init all popovers on the page
        $('.webui-popover-link').webuiPopover(
            {
                // Some of these values can be overridden by using data-attributes on the
                // popover element (see https://github.com/sandywalker/webui-popover).
                trigger: 'hover',
                animation: 'fade',
                placement: 'auto',
                closeable: true,
                multi: true,
            }
        );

        $('.webui-popover-link').on('click', function () {
            $(this).webuiPopover('show');
        });
    }
);

define("InitPopovers/main", function(){});

